import { Environment, graphql } from "relay-runtime";
import { taggableFragment$key } from "./__generated__/taggableFragment.graphql";
import { readFragmentData, refetchFragmentData } from "./relay";
import { taggableFragmentQuery } from "./__generated__/taggableFragmentQuery.graphql";

const Fragment = graphql`
  fragment taggableFragment on Taggable
  @refetchable(queryName: "taggableFragmentQuery")
  @argumentDefinitions(
    count: { type: "Int", defaultValue: 5 }
    cursor: { type: "String", defaultValue: null }
  ) {
    tagList: tags(first: $count, after: $cursor) {
      totalCount
      edges {
        node {
          name
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export async function fetchAllTags(
  environment: Environment,
  key: taggableFragment$key,
) {
  const taggable = await readFragmentData(environment, Fragment, key);

  const tags = taggable.tagList.edges.slice();

  if (taggable.tagList.edges.length < taggable.tagList.totalCount) {
    const count = taggable.tagList.totalCount - taggable.tagList.edges.length;
    const cursor = taggable.tagList.pageInfo.endCursor;
    const next = await refetchFragmentData<
      taggableFragment$key,
      taggableFragmentQuery
    >(environment, Fragment, key, { count, cursor });
    tags.push(...next.tagList.edges);
  }

  return tags;
}
